import fetch from 'isomorphic-fetch';

const MESSAGE_API_URL = process.env.REACT_APP_MESSAGE_API_URL || `https://prod-api.vmnk.in/message-service`;

export default function callmessageApi(endpoint, method = 'get', body) {
    let token =window.sessionStorage.getItem('token') ? window.sessionStorage.getItem('token') : '';

    let headers = {};
    headers['content-type'] = 'application/json';
    if (token && token !=='') {
        headers.Authorization = `Bearer ${token}`;
    }
    return fetch(`${MESSAGE_API_URL}/${endpoint}`, {
        headers: headers,
        method,
        body: JSON.stringify(body),
    })
        .then(response => response.json().then(json => ({json, response})))
        .then(({json, response}) => {
            if (!response.ok) {
                return Promise.reject(json);
            }
            return json;
        })
        .then(
            response => response,
            error => error
        );
}

